import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';


const ConviteMesclagem = () => {
    const {
      crud,
      auth,
      navigateTo,
      setTitle,
    } = useProvider();
    const { post, put, get, loading } = crud || {};
    const [convidar, setConvidar] = useState('');
    const [empresa, setEmpresa] = useState(auth?.empresa);
    const [convites, setConvites] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    
    setTitle('Sincronizar Estoque');
    const buscarConvite = async() => {
      try{
        const response = await get(
          '/gvendas/produtos-convite-mesclagem/?expand=origem,destino&ordering=data&filtros=id,data,data_aceito,nome_da_loja,is_ativo,is_sincronizado',
          'pagina'
        );
        if (response){
          //alert(JSON.stringify(response))
          setConvites(response[0].results)
        }
      }catch(err){
        
      }finally{
        
      }
    }
    
    const sendConvidar = async(e) => {
      if (e) e.preventDefault();
      
      const errors = {};
      if (convidar === '') errors.convidar = 'Por favor, informe o Slug ou Login do convite.';
      if (Object.keys(errors).length > 0) {
          setFormErrors(errors);
          return;
      }
      setFormErrors({});
      
      try{
        const formData = new FormData();
        formData.append('slug', convidar);
        const response = await post(formData, '/gvendas/produtos-convite-mesclagem/');
        if (response){
          Toast.fire({
                icon: "success",
                title: `Convite enviado com sucesso`
          });
          //alert(JSON.stringify(response))
          setConvidar('');
          buscarConvite();
        }
      }catch(err){
        //alert(JSON.stringify(err.response))
                    
        setFormErrors(prevErrors => ({ ...prevErrors, 
          apiError: err?.response?.data?.error || err.message,
          //quantidade: err.response?.data?.error,
        }));
      }finally{
        
      }
    }
    
    const updateConfirm = (item, aceito) => {
      if (!convidar){
          Swal.fire({
            title: "Remover sincronismo?",
            text: "Ao remover a sincronização, o estoque será desligado um do outro. Para unir novamente será necessário refazer todo o processo novamente.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar"
          }).then((result) => {
            if (result.isConfirmed) {
              updateConvite(item, aceito);
            }
          });
        }
    }
    
    const updateConvite = async(item, aceito) => {
      try{
        setFormErrors({});
        const formData = new FormData();
        formData.append('aceito', aceito);
        const response = await put(formData, `/gvendas/produtos-convite-mesclagem/${item.id}/`);
        if (response){
          setConvidar('');
          Toast.fire({
                icon: "success",
                title: `Convite ${aceito?'aceito':'cancelado'} com sucesso`
          });
          //alert(JSON.stringify(response))
          buscarConvite();
        }
      }catch(err){
        //alert(JSON.stringify(err.response))
                    
        setFormErrors(prevErrors => ({ ...prevErrors, 
          apiError: err?.response?.data?.message || err?.response?.data?.error || err.message,
          //quantidade: err.response?.data?.error,
        }));
      }finally{
        
      }
    }
    
    
    const formatarData = (data) => {
      if (!data) return 'Pendente'
      const d = new Date(data).toISOString().split('T')[0].split('-');
      return `${d[2]}/${d[1]}/${d[0]}`
    }
    
    
    useEffect(()=>{
      buscarConvite();
    },[setEmpresa, setConvites])
    
    return (
        <>
          <div className="text-muted pb-3">
            <b>Atenção!</b><br />
            Este recurso é ideal para casais que trabalham juntos usando o mesmo estoque. Ao aceitar ou enviar o convite para sincronização, todos os produtos estarão disponíveis para sincronizar. Além disso, toda alteração futura, tanto de um lado quanto do outro, será sincronizada automaticamente e imediatamente.
          </div>
          <div className="">
            <Card>
                <Card.Body>
                    <Form onSubmit={sendConvidar}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        <div>Meu Slug é: <i className="fs-5 text-danger">{empresa?.url}</i></div>
                        <Form.Group controlId="formNome">
                            <Form.Label>Slug ou Login de convite</Form.Label>
                            <Form.Control 
                                type="text" 
                                placeholder="Slug ou Login"
                                value={convidar} 
                                onChange={(e) => setConvidar(e.target.value)} 
                            />
                            {formErrors.convidar && <Alert variant="danger">{formErrors.convidar}</Alert>}
                        </Form.Group>
                        <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            Convidar
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
            <h4 className="mt-4">Lista de perfils de sincronização</h4>
            <div className="table-responsive my-3">
              <table className="table table-bordered w-100">
                <thead className="table-dark">
                  <tr>
                    <th>Data</th>
                    <th>Status</th>
                    <th>Origem</th>
                    <th>Destino</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {convites.map((item, index) => (
                    <tr>
                      <td>{formatarData(item.data)}</td>
                      <td>{formatarData(item.data_aceito)}</td>
                      <td>{item.origem?.nome_da_loja}</td>
                      <td>{item.destino?.nome_da_loja}</td>
                      <td>
                        {item.is_ativo ? (
                          <div className="btn-group" role="group" aria-label="Button group">
                            <Button variant="danger" onClick={() => updateConfirm(item, false)}>
                              Remover
                            </Button>
                            <Button variant={item.is_sincronizado?'success':'warning'} onClick={() => navigateTo('/produtos/sincronizar')}>
                              <i className={`bi bi-repeat${item.is_sincronizado?'':'-1'}`}></i> {item.is_sincronizado?'Sincronizado':'Sincronizar'}
                            </Button>
                          </div>
                        ) : (
                          <div className="btn-group" role="group" aria-label="Button group">
                            <Button variant="danger" onClick={() => updateConvite(item, false)}>
                              Recusar
                            </Button>
                            <Button variant="success" onClick={() => updateConvite(item, true)}>
                              Aceitar
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
        </div>
        </>
    );
};

export default ConviteMesclagem;